import React from 'react'
import routes from 'src/lib/rails-routes/rails-routes'
import { CefrLevelCode, SubscriptionCode, Plan } from 'src/types'

import SideNote from 'src/ui/SideNote/SideNote'

import casualIcon from './assets/casual.svg'
import seriousIcon from './assets/serious.svg'
import ultimateIcon from './assets/ultimate.svg'
import { t } from 'src/lib/i18n-react'

const PLANS: { [key: string]: { iconUrl: string | null } } = {
  [SubscriptionCode.lite]: {
    iconUrl: null, // it will never be visible as an upgrade option
  },
  [SubscriptionCode.casual]: {
    iconUrl: casualIcon,
  },
  [SubscriptionCode.serious]: {
    iconUrl: seriousIcon,
  },
  [SubscriptionCode.ultimate]: {
    iconUrl: ultimateIcon,
  },
}

export type Props = {
  goalCefrLevel: CefrLevelCode
  predictedNumberOfLessonsPerMonth: number
  predictedDateOfCompletion: string
  recommendedPlan?: Plan
}

const GoalPredictionSideNote: React.FC<Props> = ({
  goalCefrLevel,
  predictedNumberOfLessonsPerMonth,
  predictedDateOfCompletion,
  recommendedPlan,
}) => {
  if (predictedNumberOfLessonsPerMonth <= 1) {
    return (
      <SideNote
        message={t(
          'At this rate, you can study at your own pace and check in with a tutor at anytime.'
        )}
      />
    )
  }

  const predictionString = t(
    'At this rate, you will complete %{cefrLevel} around <strong>%{date}</strong>.',
    {
      cefrLevel: goalCefrLevel.toUpperCase(),
      date: predictedDateOfCompletion,
    }
  )

  if (recommendedPlan) {
    const newPlanString = t(
      'You need to take %{numberOfLessons} Live Lessons per month. The <strong>%{planName}</strong> plan is the most efficient plan for you.',
      {
        numberOfLessons: predictedNumberOfLessonsPerMonth,
        planName: recommendedPlan.label,
      }
    )

    return (
      <SideNote
        message={`${predictionString}<br/>${newPlanString}`}
        iconUrl={PLANS[recommendedPlan.label.toLowerCase()]?.iconUrl}
        link={{
          url: routes.new_payments_subscription(),
          label: t('Change your plan'),
        }}
      />
    )
  }

  return <SideNote message={predictionString} />
}

export default GoalPredictionSideNote
